<template>
  <div class="cmp-catalog-releases-sidewindow-release-setup">
    <TextField2
      id="release_title"
      :placeholder="$t('release_title')"
      :label="$t('release_title')"
      :value="selectedReleaseDetails.release.release_title"
      :disabled="false"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      id="release_artist"
      class="m1"
      :placeholder="$t('release_artist')"
      :label="$t('release_artist')"
      :value="selectedReleaseDetails.release.release_artist"
      :showImmediate="true"
      autocomplete="off"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <Dropdown2
      id="release_type"
      :label="$t('release_type')"
      :placeholder="$t('select') + ' ' + $t('release_type')"
      :disabled="false"
      :options="selectedReleaseDetails.release_typesTV"
      :selected="
        releaseTypeTV.find(
          (e) => e.value == selectedReleaseDetails.release.release_type
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('release_type', e)"
    />
    <Dropdown2
      :options="selectedReleaseDetails.label_statusesTV"
      id="label_status_id"
      :label="$t('releases_status')"
      :placeholder="$t('releases_status')"
      @selectedChange="(e) => onDropdownChange('label_status_id', e)"
      :selected="
        selectedReleaseDetails.label_statusesTV.find(
          (e) => e.value == selectedReleaseDetails.release.label_status_id
        )
      "
    />
    <DatePicker2
      :disabled="false"
      id="termination_date"
      :label="'Termination Date'"
      v-if="selectedReleaseDetails.release.termination_date"
      :value="selectedReleaseDetails.release.termination_date"
      @input="(e) => onDateChange(e)"
    />

    <DatePicker2
      :disabled="false"
      id="release_date"
     
      :label="$t('release_date')"
      :value="selectedReleaseDetails.release.release_date"
      @input="(e) => onDateChange(e)"
      :hint="$t('release_date_info')"
    />
    <TextField2
      id="identifier"
      :placeholder="$t('release_code')"
      :label="$t('release_code')"
      :value="selectedReleaseDetails.release.identifier"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <Dropdown2
      :label="$t('label_name')"
      :placeholder="$t('select') + ' ' + $t('label_name')"
      :disabled="false"
      :options="selectedReleaseDetails.labelsTV"
      id="label_id"
      v-on:selectedChange="(e) => onDropdownChange('label_id', e)"
      :selected="
        selectedReleaseDetails.labelsTV.find(
          (e) => e.value == selectedReleaseDetails.release.label_id
        )
      "
    />
    <Dropdown2
      :options="selectedReleaseDetails.projectsTV"
      id="project_id"
      :label="$t('project_name')"
      :placeholder="$t('project_name')"
      :selected="
        selectedReleaseDetails.projectsTV.find(
          (e) => e.value == selectedReleaseDetails.release.project_id
        )
      "
      @selectedChange="(e) => onDropdownChange('project_id', e)"
    />
    <TextField2
      id="contract_key"
      :bb="'0px'"
      :placeholder="$t('contract_key')"
      :label="$t('contract_key')"
      :value="selectedReleaseDetails.release.contract_key"
      :disabled="false"
      @blur="(e) => onTextFieldValueChange(e)"
    />
  </div>
</template>
<script>
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { tv } from "../../../../models/text-value.model";

export default {
  props: {
    selectedReleaseDetails: {
      type: Object,
    },
  },

  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      releaseArtist: "",
      releaseTitle: "",
      releaseDate: "",
      releaseCode: "",
    };
  },
  methods: {
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
      console.log("WERERTYUPOIUN", payload);
    },
    onDropdownChange: function (name, e) {
      const payload = {
        name: name,
        value: e.value,
      };
      this.$emit("changed", payload);
      console.log("WERERTYUPOIUN", payload);
    },
    onDateChange: async function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
        this.$emit("changed", payload);

      // if (e.name === "release_date") {
      //   const { name, value, item } = payload;
      //   const release_id = this.$route.params.release_id;
      //   const MHTTPCL = this.$http;
      //   const modifiedRelease = await MHTTPCL.modifyJSON(
      //     "release_id",
      //     release_id,
      //     name,
      //     value,
      //     "l_releases"
      //   );

      //   const confirmationResult = await ConfirmationService.createP({
      //     width: 376,
      //     body: "Do you want to set this date for all related products ?",
      //     results: [
      //       createConfirmResult({
      //         value: "No",
      //         classes: ["ut-mt-0 ut-mb-0"],
      //       }),
      //       createConfirmResult({
      //         value: "Yes",
      //         classes: ["v1 ut-mt-0 ut-mb-0"],
      //       }),
      //     ],
      //   });
      //   if (confirmationResult === "Yes") {
      //     console.log("YES", payload);
      //   }
      // } else {
      // }

      console.log("WERERTYUPOIUN", payload);
    },
  },
  computed: {
    releaseTypeTV: function () {
      return (
        this.selectedReleaseDetails?.release_types?.map((e) => {
          return {
            text: this.$t(e["textkey"]),
            value: e["value"],
          };
        }) || []
      );
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-release-setup {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
